import React from 'react';
import {
    Spinner, SpinnerSize,
    IconButton,
    Stack, Text, Icon
} from '@fluentui/react';
import { RagStore } from '../../ata/types';
import styles from './AtaRagStoreList.module.css';

interface AtaRagStoreListProps {
    stores: RagStore[];
    selectedStore: RagStore | null;
    isLoading: boolean;
    onSelect: (store: RagStore) => void;
    onRefresh: () => void;
}

const AtaRagStoreList: React.FC<AtaRagStoreListProps> = ({
    stores, selectedStore, isLoading, onSelect, onRefresh
}) => {
    return (
        <div className={styles.container}>
            <Stack
                horizontal
                horizontalAlign="space-between"
                verticalAlign="center"
                className={styles.header}
            >
                <Stack horizontal verticalAlign="center" tokens={{ childrenGap: 8 }}>
                    <Icon iconName="FolderList" className={styles.headerIcon} />
                    <Text variant="large" className={styles.title}>
                        Catégories
                    </Text>
                </Stack>
                <IconButton
                    iconProps={{ iconName: 'Refresh' }}
                    title="Actualiser les catégories"
                    onClick={onRefresh}
                    disabled={isLoading}
                    styles={{ root: { color: '#605e5c' } }}
                />
            </Stack>

            {isLoading && stores.length === 0 ? (
                <div className={styles.centered}>
                    <Spinner size={SpinnerSize.medium} label="Chargement…" />
                </div>
            ) : stores.length === 0 ? (
                <div className={styles.centered}>
                    <Icon iconName="FolderOpen" className={styles.emptyIcon} />
                    <Text className={styles.emptyText}>Aucune catégorie disponible</Text>
                    <Text className={styles.emptySubtext}>
                        Contactez un administrateur pour accéder aux catégories.
                    </Text>
                </div>
            ) : (
                <ul className={styles.list}>
                    {stores.map(store => (
                        <li key={store.displayName} className={styles.listItem}>
                            <button
                                className={`${styles.storeBtn} ${
                                    selectedStore?.displayName === store.displayName
                                        ? styles.storeBtnActive
                                        : ''
                                }`}
                                onClick={() => onSelect(store)}
                                title={store.displayName}
                            >
                                <Icon
                                    iconName={store.storeExists === false ? 'Warning' : 'DocumentSet'}
                                    className={styles.storeIcon}
                                    style={store.storeExists === false ? { color: '#ca5010' } : undefined}
                                />
                                <span className={styles.storeName}>{store.displayName}</span>
                                {store.storeExists === false && (
                                    <span style={{
                                        fontSize: 10,
                                        color: '#ca5010',
                                        background: '#fde7d0',
                                        borderRadius: 4,
                                        padding: '1px 5px',
                                        marginLeft: 6,
                                        whiteSpace: 'nowrap'
                                    }}>Non configuré</span>
                                )}
                            </button>
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
};

export default AtaRagStoreList;
